import { render, staticRenderFns } from "./upload-report.vue?vue&type=template&id=4afc9a93&scoped=true"
import script from "./upload-report.vue?vue&type=script&lang=js"
export * from "./upload-report.vue?vue&type=script&lang=js"
import style0 from "./upload-report.vue?vue&type=style&index=0&id=4afc9a93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc9a93",
  null
  
)

export default component.exports